import React, { useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    Label,
    Button,
    Table,
    CardHeader,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import profileDefault from "../../../assets/images/users/indian_stud_1.jpg";

const FeeStatement = () => {
    // State for selected class, division, and student
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("");
    const [selectedStudent, setSelectedStudent] = useState("");

    // State for search input
    const [searchQuery, setSearchQuery] = useState("");

    // State to store filtered fee statements
    const [filteredFeeStatements, setFilteredFeeStatements] = useState([]);

    // State to track if the form has been submitted
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Dummy data for classes, divisions, and students
    const classes = [
        { id: 1, name: "Class 1" },
        { id: 2, name: "Class 2" },
        { id: 3, name: "Class 3" },
    ];

    const divisions = [
        { id: 1, name: "Division A", classId: 1 },
        { id: 2, name: "Division B", classId: 1 },
        { id: 3, name: "Division A", classId: 2 },
        { id: 4, name: "Division B", classId: 2 },
    ];

    const students = [
        // Class 1 - Division A
        {
            id: 1,
            name: "John Doe",
            fatherName: "Mr. Doe",
            phone: "9876543210",
            category: "General",
            classId: 1,
            divisionId: 1,
            admissionNumber: "12345",
            rollNumber: "101",
            image: "",
        },
        {
            id: 2,
            name: "Jane Smith",
            fatherName: "Mr. Smith",
            phone: "9876543211",
            category: "OBC",
            classId: 1,
            divisionId: 1,
            admissionNumber: "12346",
            rollNumber: "102",
            image: "",
        },
        {
            id: 3,
            name: "Alice Johnson",
            fatherName: "Mr. Johnson",
            phone: "9876543212",
            category: "SC",
            classId: 1,
            divisionId: 1,
            admissionNumber: "12347",
            rollNumber: "103",
            image: "",
        },

        // Class 1 - Division B
        {
            id: 4,
            name: "Bob Brown",
            fatherName: "Mr. Brown",
            phone: "9876543213",
            category: "ST",
            classId: 1,
            divisionId: 2,
            admissionNumber: "12348",
            rollNumber: "104",
            image: "",
        },
        {
            id: 5,
            name: "Charlie Davis",
            fatherName: "Mr. Davis",
            phone: "9876543214",
            category: "General",
            classId: 1,
            divisionId: 2,
            admissionNumber: "12349",
            rollNumber: "105",
            image: "",
        },
        {
            id: 6,
            name: "Eva Green",
            fatherName: "Mr. Green",
            phone: "9876543215",
            category: "OBC",
            classId: 1,
            divisionId: 2,
            admissionNumber: "12350",
            rollNumber: "106",
            image: "",
        },

        // Class 2 - Division A
        {
            id: 7,
            name: "Frank White",
            fatherName: "Mr. White",
            phone: "9876543216",
            category: "General",
            classId: 2,
            divisionId: 3,
            admissionNumber: "12351",
            rollNumber: "107",
            image: "",
        },
        {
            id: 8,
            name: "Grace Hall",
            fatherName: "Mr. Hall",
            phone: "9876543217",
            category: "OBC",
            classId: 2,
            divisionId: 3,
            admissionNumber: "12352",
            rollNumber: "108",
            image: "",
        },
        {
            id: 9,
            name: "Henry Wilson",
            fatherName: "Mr. Wilson",
            phone: "9876543218",
            category: "SC",
            classId: 2,
            divisionId: 3,
            admissionNumber: "12353",
            rollNumber: "109",
            image: "",
        },

        // Class 2 - Division B
        {
            id: 10,
            name: "Ivy Moore",
            fatherName: "Mr. Moore",
            phone: "9876543219",
            category: "ST",
            classId: 2,
            divisionId: 4,
            admissionNumber: "12354",
            rollNumber: "110",
            image: "",
        },
        {
            id: 11,
            name: "Jack Taylor",
            fatherName: "Mr. Taylor",
            phone: "9876543220",
            category: "General",
            classId: 2,
            divisionId: 4,
            admissionNumber: "12355",
            rollNumber: "111",
            image: "",
        },
        {
            id: 12,
            name: "Karen Lee",
            fatherName: "Mr. Lee",
            phone: "9876543221",
            category: "OBC",
            classId: 2,
            divisionId: 4,
            admissionNumber: "12356",
            rollNumber: "112",
            image: "",
        },
    ];

    // Dummy data for fee statements
    const feeStatements = [
        {
            id: 1,
            studentId: 1,
            fees: [
                {
                    siNo: 1,
                    feeGroup: "Admission Fees",
                    feeCode: "ADM001",
                    dueDate: "2023-10-01",
                    status: "Paid",
                    amount: 10000,
                    discount: 1000,
                    fine: 0,
                    paid: 9000,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feeGroup: "Monthly Fees",
                    feeCode: "MON001",
                    dueDate: "2023-10-15",
                    status: "Unpaid",
                    amount: 5000,
                    discount: 0,
                    fine: 100,
                    paid: 0,
                    balance: 5100,
                },
            ],
        },
        {
            id: 2,
            studentId: 2,
            fees: [
                {
                    siNo: 1,
                    feeGroup: "Admission Fees",
                    feeCode: "ADM001",
                    dueDate: "2023-10-01",
                    status: "Partial",
                    amount: 10000,
                    discount: 500,
                    fine: 50,
                    paid: 7000,
                    balance: 3550,
                },
            ],
        },
    ];

    // Handle form submission
    const handleSubmit = () => {
        // Filter fee statements based on selected student
        const filtered = feeStatements.filter(
            (statement) => statement.studentId === parseInt(selectedStudent)
        );
        setFilteredFeeStatements(filtered.length > 0 ? filtered[0].fees : []);
        setIsSubmitted(true); // Set submitted state to true
    };

    // Handle search by fee group or code
    const handleSearch = (e) => {
        const searchValue = e.target.value;
        setSearchQuery(searchValue);

        if (searchValue) {
            const filtered = feeStatements
                .filter((statement) => statement.studentId === parseInt(selectedStudent))
                .flatMap((statement) =>
                    statement.fees.filter(
                        (fee) =>
                            fee.feeGroup.toLowerCase().includes(searchValue.toLowerCase()) ||
                            fee.feeCode.toLowerCase().includes(searchValue.toLowerCase())
                    )
                );
            setFilteredFeeStatements(filtered);
        } else {
            // Reset to the original filtered fee statements
            const filtered = feeStatements.filter(
                (statement) => statement.studentId === parseInt(selectedStudent)
            );
            setFilteredFeeStatements(filtered.length > 0 ? filtered[0].fees : []);
        }
    };

    // Calculate grand totals
    const grandTotals = filteredFeeStatements.reduce(
        (totals, fee) => {
            totals.amount += fee.amount;
            totals.discount += fee.discount;
            totals.fine += fee.fine;
            totals.paid += fee.paid;
            totals.balance += fee.balance;
            return totals;
        },
        { amount: 0, discount: 0, fine: 0, paid: 0, balance: 0 }
    );

    // Get selected student details
    const selectedStudentDetails = students.find(
        (student) => student.id === parseInt(selectedStudent)
    );

    // Breadcrumb items
    const breadcrumbItems = [
        { title: "Reports", link: "/" },
        { title: "Finance Reports", link: "/" },
        { title: "Fee Statement", link: "/admin/fee-statement" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Fee Statement" breadcrumbItems={breadcrumbItems} />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center flex-wrap">
                                    <h4 className="card-title mb-0 flex-grow-1">Fee Statement</h4>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        {/* Class Select Input */}
                                        <Col lg={3}>
                                            <Label>Class</Label>
                                            <Input
                                                type="select"
                                                value={selectedClass}
                                                onChange={(e) => {
                                                    setSelectedClass(e.target.value);
                                                    setSelectedDivision(""); // Reset division
                                                    setSelectedStudent(""); // Reset student
                                                }}
                                            >
                                                <option value="">Select Class</option>
                                                {classes.map((cls) => (
                                                    <option key={cls.id} value={cls.id}>
                                                        {cls.name}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Col>

                                        {/* Division Select Input */}
                                        <Col lg={3}>
                                            <Label>Division</Label>
                                            <Input
                                                type="select"
                                                value={selectedDivision}
                                                onChange={(e) => {
                                                    setSelectedDivision(e.target.value);
                                                    setSelectedStudent(""); // Reset student
                                                }}
                                                disabled={!selectedClass}
                                            >
                                                <option value="">Select Division</option>
                                                {divisions
                                                    .filter((div) => div.classId === parseInt(selectedClass))
                                                    .map((div) => (
                                                        <option key={div.id} value={div.id}>
                                                            {div.name}
                                                        </option>
                                                    ))}
                                            </Input>
                                        </Col>

                                        {/* Student Select Input */}
                                        <Col lg={3}>
                                            <Label>Student</Label>
                                            <Input
                                                type="select"
                                                value={selectedStudent}
                                                onChange={(e) => setSelectedStudent(e.target.value)}
                                                disabled={!selectedDivision}
                                            >
                                                <option value="">Select Student</option>
                                                {students
                                                    .filter(
                                                        (student) =>
                                                            student.classId === parseInt(selectedClass) &&
                                                            student.divisionId === parseInt(selectedDivision)
                                                    )
                                                    .map((student) => (
                                                        <option key={student.id} value={student.id}>
                                                            {student.name}
                                                        </option>
                                                    ))}
                                            </Input>
                                        </Col>

                                        {/* Submit Button */}
                                        <Col lg={3} className="d-flex align-items-end">
                                            <Button color="primary" onClick={handleSubmit}>
                                                Submit
                                            </Button>
                                        </Col>
                                    </Row>

                                    {/* Show Search Bar and Table only after submission */}
                                    {isSubmitted && (
                                        <>
                                            {/* Search Input */}
                                            <Row className="mt-3">
                                                <Col lg={4}>
                                                    <Label>Search by Fee Group or Code</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearch}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* Student Details */}
                                            {selectedStudentDetails && (
                                                <Row className="mt-4">
                                                    <Col lg={12}>
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                src={selectedStudentDetails.image || profileDefault}
                                                                alt="Student"
                                                                className="me-3"
                                                                style={{ width: "100px", height: "100px" }}
                                                            />
                                                            <div>
                                                                <h5>{selectedStudentDetails.name}</h5>
                                                                <p className="mb-1">
                                                                    Class: {selectedClass} | Division: {selectedDivision} | Father: {selectedStudentDetails.fatherName} | Phone: {selectedStudentDetails.phone} | Category: {selectedStudentDetails.category} |
                                                                    Admission Number: {selectedStudentDetails.admissionNumber} | Roll Number: {selectedStudentDetails.rollNumber}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* Fee Statement Table */}
                                            <Row className="mt-4">
                                                <Col lg={12}>
                                                    {filteredFeeStatements.length > 0 ? (
                                                        <Table striped>
                                                            <thead>
                                                                <tr>
                                                                    <th>SI No</th>
                                                                    <th>Fee Group</th>
                                                                    <th>Fee Code</th>
                                                                    <th>Due Date</th>
                                                                    <th>Status</th>
                                                                    <th>Amount</th>
                                                                    <th>Discount</th>
                                                                    <th>Fine</th>
                                                                    <th>Paid</th>
                                                                    <th>Balance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filteredFeeStatements.map((fee) => (
                                                                    <tr key={fee.siNo}>
                                                                        <td>{fee.siNo}</td>
                                                                        <td>{fee.feeGroup}</td>
                                                                        <td>{fee.feeCode}</td>
                                                                        <td>{fee.dueDate}</td>
                                                                        <td>{fee.status}</td>
                                                                        <td>{fee.amount}</td>
                                                                        <td>{fee.discount}</td>
                                                                        <td>{fee.fine}</td>
                                                                        <td>{fee.paid}</td>
                                                                        <td>{fee.balance}</td>
                                                                    </tr>
                                                                ))}
                                                                {/* Grand Totals Row */}
                                                                <tr style={{ fontWeight: "bold" }}>
                                                                    <td colSpan="5">Grand Totals</td>
                                                                    <td>{grandTotals.amount}</td>
                                                                    <td>{grandTotals.discount}</td>
                                                                    <td>{grandTotals.fine}</td>
                                                                    <td>{grandTotals.paid}</td>
                                                                    <td>{grandTotals.balance}</td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <div className="text-center">
                                                            <p>No Record Found</p>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FeeStatement;